import { runModules } from './modules/runModules.js';
gsap.registerPlugin(ScrollTrigger);

// --- GSAP cleanup
function cleanup() {
  ScrollTrigger.getAll().forEach(t => t.kill());
  gsap.globalTimeline.clear();
}

// --- Helper: safe re-init
function reInitModules() {
  try {
    runModules();
  } catch (e) {
    console.error('Error re-initializing modules:', e);
  }
}

// --- Force scroll to top (Lenis + fallback)
function scrollToTop() {
  if (window.lenis) {
    window.lenis.stop();
    // zowel window als mogelijke containers resetten
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    window.lenis.scrollTo(0, { immediate: true });
    window.lenis.start();
  } else {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }
}

barba.init({
  sync: true,
  debug: false,
  transitions: [
    {
      name: 'fade',

      async once({ next }) {
        gsap.fromTo(next.container, { opacity: 0 }, { opacity: 1, duration: 0.4 });
        reInitModules();
      },

      async leave({ current }) {
        await gsap.to(current.container, { opacity: 0, duration: 0.3 });
      },

      async enter({ next }) {
        cleanup();
        gsap.set(next.container, { opacity: 0 });
        await gsap.to(next.container, { opacity: 1, duration: 0.4 });

        // Wacht 1 frame → dan scroll reset + modules opnieuw
        requestAnimationFrame(() => {
          scrollToTop();
          reInitModules();
        });
      },
    },
  ],
});

// --- Hooks
barba.hooks.beforeEnter(() => {
  // voorkom browser scrollherstel
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  // reset alvast alle mogelijke scrollcontainers
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  const main = document.querySelector('[data-barba="container"]');
  if (main) main.scrollTop = 0;
});

barba.hooks.afterEnter(() => {
  // extra zekerheid: Lenis & ScrollTrigger refresh
  scrollToTop();
  ScrollTrigger.refresh(true);
});
